var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_1777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.99994H58.0001V58H2V1.99994Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_1777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3105 19.4799C20.7648 19.9713 22.3224 20.2383 23.9426 20.2383C27.2512 20.2383 30.2997 19.1264 32.7365 17.2567C34.891 18.9611 37.565 20.0358 40.4816 20.2104C40.5826 20.2164 40.668 20.1351 40.668 20.034",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3203 29.5176H17.4875C14.5237 29.5176 12.1212 27.115 12.1212 24.1513C12.1212 21.1876 14.5237 18.7849 17.4875 18.7849H19.3203V29.5176Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.676 29.5176H42.5088C45.4726 29.5176 47.8751 27.115 47.8751 24.1513C47.8751 21.1876 45.4726 18.7849 42.5088 18.7849H40.676V29.5176Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.854 18.791V17.947C44.854 9.74351 38.2038 3.09328 30.0003 3.09328C21.7968 3.09328 15.1466 9.74351 15.1466 17.947V18.791",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.65 18.9316V18.1214C40.65 12.2473 35.8711 7.46836 29.9969 7.46836C24.1228 7.46836 19.3439 12.2473 19.3439 18.1214V18.9316",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2892 30.5469H39.4868",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7816 28.3516H29.3174C28.1045 28.3516 27.1212 29.3349 27.1212 30.5479C27.1212 31.7609 28.1045 32.7441 29.3174 32.7441H30.7816C31.9945 32.7441 32.9778 31.7609 32.9778 30.5479C32.9778 29.3349 31.9945 28.3516 30.7816 28.3516Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3185 21.055V26.457C19.3185 32.3553 24.0999 37.1367 29.9982 37.1367C35.8965 37.1367 40.678 32.3553 40.678 26.457V21.5905",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4279 39.9883V36.281",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0763 56.9062H3.09192C3.09192 47.9905 10.3195 40.763 19.2353 40.763H22.6428",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1726 40.763H40.7613C49.6769 40.763 56.9046 47.9906 56.9046 56.9062H24.0002",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5704 36.281V39.9883",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9904 44.5678L35.2292 49.8066L40.4032 42.2003L34.8356 39.7226L29.9904 44.5678Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9891 44.5678L24.7503 49.8066L19.5763 42.2003L25.1439 39.7226L29.9891 44.5678Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3);
export default __webpack_public_path__ + "static/media/d3.caa64ff51e60b08b238c107ab4c12b77.svg";
export { ForwardRef as ReactComponent };